<ng-container *transloco="let t; read: 'partials.agenda.blocks.org'">
  <div *ngIf="container" class="agenda-block">
    <app-agenda-exercise-headline
      [container]="container"
      [type]="'org'"
      [title]="container.name"
    ></app-agenda-exercise-headline>
  </div>
</ng-container>
